import React, { useState, useEffect } from "react";

const MEMORIZE_SECONDS = 5; // eats into the question's own time budget (see generator: time=20s accounts for this)

const Level3Memory = ({ question, remainingSeconds, submitting, onSubmit }) => {
  const [phase, setPhase] = useState("memorize"); // "memorize" -> "ask"

  useEffect(() => {
    setPhase("memorize");
    const t = setTimeout(() => setPhase("ask"), MEMORIZE_SECONDS * 1000);
    return () => clearTimeout(t);
  }, [question._id]);

  const askItem = question.payload.shownImages.find(
    (img) => img.id === question.payload.askImageId
  );

  const handlePick = (position) => {
    onSubmit({ selectedPosition: position });
  };

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-8 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <span className="text-xs uppercase tracking-widest text-emerald-300">
          {question.category}
        </span>
        <span className="text-2xl font-black text-yellow-300">
          ⏱ {remainingSeconds ?? "--"}s
        </span>
      </div>

      {phase === "memorize" ? (
        <>
          <h2 className="text-lg font-bold text-center mb-6 text-cyan-200">
            🧠 Remember the order!
          </h2>
          <div className="grid grid-cols-3 gap-4">
            {question.payload.shownImages.map((img, idx) => (
              <div
                key={img.id}
                className="rounded-2xl bg-white/5 border border-white/10 py-8 flex flex-col items-center gap-2"
              >
                <span className="text-6xl">{img.emoji}</span>
                <span className="text-xs text-emerald-300">Position {idx + 1}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <h2 className="text-xl font-bold text-center mb-1">
            Which position was <span className="text-4xl align-middle">{askItem?.emoji}</span>{" "}
            in?
          </h2>
          {question.payload.askTranslated && (
            <h3 className="text-base font-semibold text-center mb-6 text-cyan-200">
              {question.payload.askTranslated}
            </h3>
          )}
          {!question.payload.askTranslated && <div className="mb-6" />}
          <div className="grid grid-cols-3 gap-4">
            {[1, 2, 3].map((pos) => (
              <button
                key={pos}
                onClick={() => handlePick(pos)}
                disabled={submitting}
                className="rounded-2xl bg-white/5 border border-white/10 hover:bg-emerald-500/20 hover:border-emerald-400 py-8 text-3xl font-black transition-all disabled:opacity-40"
              >
                {pos}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Level3Memory;
